import React, { useEffect } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Stack,
} from "@mui/material";

import { useParams } from "react-router-dom";
import ScheduleComponent from "./ScheduleComponent";

const SubTaskModal = ({ open, onClose, taskGroupName, tasks }) => {
  const { id: projectId } = useParams();
  // const { accessToken } = useContext(AuthContext);
  const [rows, setRows] = React.useState([]);

  useEffect(() => {
    console.log("tasks", taskGroupName, tasks);
    const filteredTasks = tasks.filter((t) => t.taskCode === taskGroupName);
    const convertedTasks = filteredTasks.map((task) => {
      return {
        name: task.task,
        plannedStart: task.startDate?.slice(0, 10) || null,
        plannedEnd: task.targetDate?.slice(0, 10) || null,
        actualStart: task.actualStart?.slice(0, 10) || null,
        actualEnd: task.actualEnd?.slice(0, 10) || null,
        progress: task.progress ?? 0,
      };
    });

    setRows(convertedTasks);
  }, [taskGroupName, tasks]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle>Task Group: {taskGroupName}</DialogTitle>
      <DialogContent>
        {rows && rows.length > 0 ? (
          <Box p={2}>
            <Stack
              sx={{ paddingBottom: "2rem" }}
              direction={"row"}
              justifyContent="space-between"
              height={"3rem"}
              alignItems="center"
            >
              <h2>Schedule</h2>
            </Stack>
            <ScheduleComponent
              rows={rows}
              setRows={undefined}
              projectId={projectId}
            />
          </Box>
        ) : (
          <h2>there's no sub tasks for this task</h2>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default SubTaskModal;
